import { useEffect, useState } from "react";
import { ClipboardList, Loader2 } from "lucide-react";
import { TaskCard } from "@/components/TaskCard";
import { api } from "@/lib/api";

export default function Tasks() {
  const [tasks, setTasks] = useState(null);

  useEffect(() => {
    api.get("/tasks/public").then((r) => setTasks(r.data)).catch(() => setTasks([]));
  }, []);

  return (
    <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12 sm:py-16">
      <div className="animate-fade-up">
        <h1 className="text-3xl sm:text-4xl font-bold tracking-tight text-slate-900 font-heading" data-testid="tasks-page-heading">Available Tasks</h1>
        <p className="mt-3 text-base sm:text-lg text-slate-600 max-w-2xl">Pick a task, install the app, share your honest feedback and earn rewards. New tasks are added regularly.</p>
      </div>

      {tasks === null ? (
        <div className="py-20 flex justify-center"><Loader2 className="w-8 h-8 animate-spin text-blue-600" data-testid="tasks-loading" /></div>
      ) : tasks.length === 0 ? (
        <div className="mt-10 bg-white rounded-2xl border border-slate-200/80 p-12 text-center" data-testid="tasks-empty-state">
          <ClipboardList className="w-12 h-12 text-slate-300 mx-auto" />
          <h3 className="mt-4 font-heading font-semibold text-slate-900 text-lg">No active tasks right now</h3>
          <p className="mt-2 text-sm text-slate-500">Please check back soon — new testing opportunities are added frequently.</p>
        </div>
      ) : (
        <div className="mt-8 grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-5 sm:gap-6" data-testid="tasks-grid">
          {tasks.map((t, i) => <TaskCard key={t.id} task={t} index={i} />)}
        </div>
      )}
    </div>
  );
}
